<template>
    <div style="height:100%;">
        <p style="display: flex;
         font-size: 30px;
         flex-direction: row;
         height: 45px;
         color: rgb(221,114,2);
         border-bottom: solid 0.06rem rgb(193,193,193);">
          WEAT enrichment analysis: DisGeNET scores
        </p> 
        <el-card style="width:100%;
               height:auto;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;">
               <div style="width:95%;display: inline-block;vertical-align: middle;margin:auto;font-size: 18px;text-align: left;line-height: 30px;">
                In this section, we show the results of <strong style="font-size:22px;">GO enrichment</strong> analysis and <strong style="font-size:22px;">KEGG pathway enrichment</strong> analysis 
                using the weighted enrichment analysis tool <a href="http://www.cuilab.cn/weat/">WEAT</a>. 
                We used the gene score generated by DisGeNET to weight each gene, which reflects the strength of association between MDD and genes.   
               </div>
        </el-card>    
        <el-tabs style="height:100%;margin-top: 50px;" type="border-card" v-model="activePane" @tab-click="handleClick">
        <!-- Data -->
            <el-tab-pane label="GO enrichment" name="go">
                Select domains: 
                <el-select @change="selectChanged" v-model="activeType" placeholder="Choose type" >
                    <el-option
                        v-for="item in typeOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <br/><br/>
                <BubblechartVue :plotData="plotData" :name="yaxis" v-if="activePane=='go'"></BubblechartVue>
                <el-table ref="GOtable" class="table" :data="tableData"  style="width: 98%;margin: auto;" height=650px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                    <el-table-column v-for='(item,key)  in tableFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :min-width="item.minWidth"/>          
                </el-table>
                <el-pagination
                    @size-change="(val) => handleSizeChange(val)"
                    @current-change="(val) => handleCurrentChange(val)"
                    :current-page="currentPage"
                    :page-sizes="[10,20,30]"
                    :page-size="10"
                    layout="->,total, sizes, prev, pager, next, jumper"
                    :total= this.totalCount
                    style="margin-left:auto">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="KEGG pathway enrichment" name="kegg">
                <br/><br/>
                <BubblechartVue :plotData="KEGGData" :name="yaxis" v-if="activePane=='kegg'"></BubblechartVue>
                <el-table ref="KEGGtable" class="table" :data="tableData"  style="width: 98%;margin: auto;" height=650px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
                    <el-table-column v-for='(item,key)  in tableFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :min-width="item.minWidth"/>          
                </el-table>
                <el-pagination
                    @size-change="(val) => handleSizeChange(val)"
                    @current-change="(val) => handleCurrentChange(val)"
                    :current-page="currentPage"
                    :page-sizes="[10,20,30]"
                    :page-size="10"
                    layout="->,total, sizes, prev, pager, next, jumper"
                    :total= this.totalCount
                    style="margin-left:auto">
                </el-pagination>
            </el-tab-pane>
           
        </el-tabs>
    </div>
</template>

<script>
import BubblechartVue from '../../../chart/BubbleWeatchart.vue';
import{Loading}from'element-ui';
export default{
    data(){    
        return{
            tableData:[],
            yaxis:'GO term',
            // 默认显示第几页
            currentPage:1,
            // 总条数，根据接口获取数据长度(注意：这里不能为空)
            totalCount:1,
            // 默认每页显示的条数（可修改）
            pageSize:10,
            desc:null,
            sortby:null,
            activePane:"go",
            activeType:'Biological Process',
            tableFields: [
                { key: "description", label: "Description", sortable: true,width:'150px'},
                { key: "count_ratio", label: "Count ratio", sortable: true,width:120},
                { key: "score_ratio", label: "Score ratio", sortable: true,width:120},
                { key: "or", label: "OR", sortable: true,width:100},
                { key: "wor", label: "WOR", sortable: true,width:110},
                { key: "wpvalue", label: "WP-value", sortable: true ,width:110},
                { key: "bonferroni", label: "Bonferroni",sortable: true ,width:120,formatter:this.rounding},
                { key: "fdr", label: "FDR",sortable: true ,width:100,formatter:this.rounding},
                { key: "gene_name", label: "Gene name", sortable: true,minWidth:350},
                // { key: "type", label: "Category", sortable: true,width:120},
                // { key: "background", label: "Score generation", sortable: true,width:120}
            ],
            typeOption:[{
                value: 'Biological Process',
                label: 'Biological Process'
                },{
                value: 'Cellular Component',
                label: 'Cellular Component'
                },{
                value: 'Molecular Function',
                label: 'Molecular Function'
                }],
            plotData: null,
            BPData:[[0.321138211382114,'chemical synaptic transmission','79/246','6.18','79.00/246.00','6.18',3.46E-30,4.25E-26,4.25E-26,79,29.4609239012072],
                [0.171919770773639,'signal transduction','180/1047','2.82','180.00/1047.00','2.82',2.04E-27,2.5E-23,1.25E-23,180,26.6903698325741],
                [0.276223776223776,'cytokine-mediated signaling pathway','79/286','4.97','79.00/286.00','4.97',2.51E-25,3.08E-21,1.03E-21,79,24.600326278519],
                [0.28125,'response to drug','72/256','5.07','72.00/256.00','5.07',1.08E-23,1.33E-19,3.31E-20,72,22.966576244513],
                [0.22680412371134,'inflammatory response','88/388','3.83','88.00/388.00','3.83',1.26E-21,1.55E-17,3.1E-18,88,20.8996294548824],
                [0.221932114882507,'positive regulation of gene expression','85/383','3.71','85.00/383.00','3.71',2.81E-20,0.000000000000000345,5.74E-17,85,19.5512936800949],
                [0.333333333333333,'response to lipopolysaccharide','46/138','6.39','46.00/138.00','6.39',7.94E-19,0.00000000000000974,0.00000000000000139,46,18.1001794975729],
                [0.307692307692308,'aging','48/156','5.68','48.00/156.00','5.68',5.76E-18,0.0000000000000707,0.00000000000000785,48,17.2395775165768],
                [0.307692307692308,'response to hypoxia','48/156','5.68','48.00/156.00','5.68',5.76E-18,0.0000000000000707,0.00000000000000785,48,17.2395775165768],
                [0.416666666666667,'circadian rhythm','30/72','9.04','30.00/72.00','9.04',0.000000000000000844,0.0000000000104,0.00000000000104,30,15.0736575533743],

                ],
            MFData:[[0.198879551820728,'enzyme binding','71/357','3.24','71.00/357.00','3.24',0.00000000000000916,0.0000000000397,0.0000000000397,71,14.0381045263322],
                [0.195530726256983,'signaling receptor binding','70/358','3.17','70.00/358.00','3.17',0.0000000000000344,0.000000000149,0.0000000000746,70,13.4634415574285],
                [0.240641711229947,'cytokine activity','45/187','4.08','45.00/187.00','4.08',0.00000000000083,0.0000000036,0.0000000012,45,12.0809219076239],
                [0.122168840082361,'identical protein binding','178/1457','1.86','178.00/1457.00','1.86',0.00000000000492,0.0000000213,0.00000000533,178,11.3080348972326],
                [0.245398773006135,'growth factor activity','40/163','4.18','40.00/163.00','4.18',0.00000000000796,0.0000000345,0.0000000069,40,11.0990869322623],
                [0.0821773343068062,'protein binding','1013/12327','1.51','1013.00/12327.00','1.51',0.0000000000617,0.000000267,0.0000000446,1013,10.2097148359668],
                [0.204878048780488,'transcription regulatory region sequence-specific DNA binding','42/205','3.31','42.00/205.00','3.31',0.00000000107,0.00000465,0.000000665,42,8.97061622231479],
                [0.466666666666667,'neuropeptide hormone activity','14/30','11.1','14.00/30.00','11.1',0.0000000062,0.0000269,0.00000336,14,8.20760831050175],
                [0.75,'serotonin binding','9/12','37.94','9.00/12.00','37.94',0.0000000113,0.0000488,0.0000046,9,7.94692155651658],
                [1,'extracellularly ATP-gated cation channel activity','7/7','Infinity','7.00/7.00','Infinity',0.0000000117,0.0000506,0.0000046,7,7.93181413825384],

                ],
            CCData:[[0.145989304812834,'extracellular region','273/1870','2.52','273.00/1870.00','2.52',3.09E-32,5.43E-29,5.43E-29,273,31.5100415205752],
                [0.248768472906404,'dendrite','101/406','4.55','101.00/406.00','4.55',2.31E-29,4.07E-26,2.04E-26,101,28.6363880201079],
                [0.145398773006135,'extracellular space','237/1630','2.45','237.00/1630.00','2.45',1.8E-27,3.16E-24,1.05E-24,237,26.7447274948967],
                [0.147100424328147,'integral component of plasma membrane','208/1414','2.45','208.00/1414.00','2.45',1.2E-24,2.11E-21,5.28E-22,208,23.9208187539524],
                [0.104369961815868,'plasma membrane','492/4714','1.8','492.00/4714.00','1.8',3.9E-22,6.86E-19,1.37E-19,492,21.4089353929735],
                [0.2398753894081,'neuron projection','77/321','4.27','77.00/321.00','4.27',1.42E-21,2.5E-18,4.17E-19,77,20.8477116556169],
                [0.236363636363636,'neuronal cell body','78/330','4.19','78.00/330.00','4.19',2.04E-21,3.59E-18,5.13E-19,78,20.6903698325741],
                [0.223684210526316,'glutamatergic synapse','68/304','3.87','68.00/304.00','3.87',1.78E-17,0.0000000000000313,0.00000000000000392,68,16.7495799976911],
                [0.21523178807947,'axon','65/302','3.67','65.00/302.00','3.67',0.000000000000000695,0.00000000000122,0.000000000000136,65,15.1580151954099],
                [0.283687943262411,'postsynaptic membrane','40/141','5.25','40.00/141.00','5.25',0.0000000000000202,0.0000000000355,0.00000000000355,40,13.6946486305534],

            ],
            KEGGData: [[0.328729281767956,'Neuroactive ligand-receptor interaction','119/362','4.78','119.00/362.00','4.78',2.99E-33,1.05E-30,1.05E-30,119,32.5243288116756],
                [0.304166666666667,'Calcium signaling pathway','73/240','4.06','73.00/240.00','4.06',2.28E-18,0.000000000000000798,0.000000000000000399,73,17.6420651529995],
                [0.412280701754386,'Glutamatergic synapse','47/114','6.38','47.00/114.00','6.38',4.47E-18,0.00000000000000156,0.000000000000000521,47,17.3496924768681],
                [0.297674418604651,'Lipid and atherosclerosis','64/215','3.9','64.00/215.00','3.9',0.00000000000000103,0.00000000000036,0.0000000000000899,64,14.9871627752948],
                [0.289592760180996,'cAMP signaling pathway','64/221','3.74','64.00/221.00','3.74',0.00000000000000448,0.00000000000157,0.000000000000288,64,14.3487219860019],
                [0.385321100917431,'HIF-1 signaling pathway','42/109','5.67','42.00/109.00','5.67',0.00000000000000494,0.00000000000173,0.000000000000288,42,14.3062730510764],
                [0.373913043478261,'Serotonergic synapse','43/115','5.4','43.00/115.00','5.4',0.00000000000000825,0.00000000000289,0.000000000000413,43,14.0835460514501],
                [0.207156308851224,'Pathways in cancer','110/531','2.46','110.00/531.00','2.46',0.000000000000163,0.0000000000569,0.00000000000711,110,12.787812395596],
                [0.333333333333333,'Dopaminergic synapse','44/132','4.52','44.00/132.00','4.52',0.00000000000046,0.000000000161,0.0000000000179,44,12.3372421683184],
                [0.382978723404255,'IL-17 signaling pathway','36/94','5.58','36.00/94.00','5.58',0.000000000000566,0.000000000198,0.0000000000198,36,12.2471835688117],
                ]
        }
    },
    components:{
        BubblechartVue
    },
    mounted () {
        this.plotData=this.BPData
        this.getData()
    },
    watch:{
        activeType:function(){
            if(this.activeType=='Biological Process'){
                this.plotData=this.BPData
            }else if(this.activeType=='Cellular Component'){
                this.plotData=this.CCData
            }else {
                this.plotData=this.MFData
            }
        }
    },
    methods:{
        getData(){
            console.log(this.activePane=="go"?this.activeType:"KEGG")
            var loadingInstance = Loading.service({
                target:document.querySelector('.table')
            });
            this.axios.get(this.GLOBAL.rootAddress+'analysis/enrichment/weat_disgenet',{
            params: { 
                'pageNum': this.currentPage,
                'pageSize': this.pageSize,
                'sortBy':this.sortby,
                'desc':this.desc,
                'type':this.activePane=="go"?this.activeType:"KEGG"
            }
            })
            .then(response=> {
                loadingInstance.close();
                this.totalCount=response.data.data.total;               
                this.tableData=response.data.data.records;   
            })
            .catch(error=> {
                loadingInstance.close();
                console.log(error);
            });
        },
        handleClick(val){
            this.getData() 
            this.currentPage=1
            if(this.activePane=='go')this.yaxis="GO term"
            else this.yaxis="KEGG pathway"
        },
        // 改变每页显示的条数 
        handleSizeChange(val) { 
            this.pageSize=val
            this.currentPage=1
            this.getData()            
            },
        // 改变当前页数
        handleCurrentChange(val) {
            this.currentPage=val
            this.getData()
        },
        sortChange(column, prop, order){
            this.currentPage=1
            if(column.order){
                this.sortby=column.prop
                if(column.order=='ascending'){
                    this.desc=1
                }else this.desc=0
            }else{
                this.sortby=null
                this.desc=null
            }
            this.getData()
        },
        rounding(row,column) {
            return row[column.property].toExponential(3)
        },
        selectChanged(){
            if (this.$refs.table){
                this.$refs.table.clearSort()
            }
            this.currentPage=1
            this.currentPageIndex=0
            this.desc=null
            this.sortby=null
            this.pageSize=10
            this.getData()
        },

    },
}


</script>

<style>

</style>